export default {"src":"/_next/static/media/bg.c9d64752.svg","height":235,"width":1216,"blurWidth":0,"blurHeight":0};